"use strict";

const Inclusions = () => {
    const init = () => {
        $(function() {
            var $toggle = $('.js-inclusions-toggle');
            var $close = $('.js-inclusions-close');
            var $categories = $('.js-inclusions-categories');
            if ($toggle.length > 0) {
                $toggle.on('click', function(){
                    $categories.addClass('open');
                });

                $close.on('click', function(){
                    if($(window).scrollTop() > 0) {
                        $('html, body').animate({
                            scrollTop: $(this).parents('.js-tabs').offset().top
                        }, 100);
                    }
                    $categories.removeClass('open');
                });
            }

            var $tabs = $('.js-compare-tab');
            var $columns = $('.js-compare-column');
            if ($tabs.length > 0) {
                $tabs.on('click', function(){
                    $tabs.removeClass('active');
                    $columns.removeClass('active');
                    $(this).addClass('active');
                    $columns.filter('[data-id="'+$(this).data('id')+'"]').addClass('active');
                });
                $tabs.filter(':first-child').click();
                if ($tabs.filter(`.listing-toggle`).length > 0) {
                    $tabs.filter(`.listing-toggle`)[0].click();
                }
            }
        });
    };

    return {
        init:init
    };
};

export default Inclusions;